<h1 mat-dialog-title>{{ 'NAVBAR.FILTERS.TITLE' | translate }}</h1>

<mat-dialog-content>
  <form class="flex flex-col gap-y-2" [formGroup]="filterForm">
    <div class="flex flex-col">
      <span class="font-semibold text-dnv-secondary mb-2">{{
        'NAVBAR.FILTERS.LABEL_EVENT' | translate
      }}</span>
      <div class="border border-dnv-primary rounded-full p-3">
        <mat-select
          [placeholder]="'NAVBAR.FILTERS.PLACEHOLDER_EVENT' | translate"
          panelWidth="35%"
          panelClass="bg-white!"
          formControlName="eventType"
        >
          @for (event of eventArray; track event) {
            <mat-option [value]="event">
              <span> {{ 'PNS_LIST_TABLE.TYPES.' + event | translate }} </span>
            </mat-option>
          }
        </mat-select>
      </div>
    </div>
    <div class="flex flex-col mt-6">
      <span class="font-semibold text-dnv-secondary mb-2">{{
        'NAVBAR.FILTERS.LABEL_DATE' | translate
      }}</span>
      <div class="flex w-full gap-4 items-center justify-between">
        <input
          type="date"
          class="p-3 rounded-full border border-dnv-primary w-full focus:outline-dnv-secondary"
          formControlName="startDate"
        />
        <input
          type="date"
          class="p-3 rounded-full border border-dnv-primary w-full focus:outline-dnv-secondary"
          formControlName="endDate"
        />
      </div>
      <div class="flex flex-col mt-6">
        <span class="font-semibold text-dnv-secondary mb-2">{{
          'NAVBAR.FILTERS.LABEL_PNS' | translate
        }}</span>
        <div class="border border-dnv-primary rounded-full p-3">
          <input
            type="text"
            [placeholder]="'NAVBAR.FILTERS.PLACEHOLDER_PNS' | translate"
            matInput
            formControlName="pns"
            [matAutocomplete]="autoPns"
            class="w-full border-none outline-none focus:outline-none bg-transparent"
          />
          <mat-autocomplete autoActiveFirstOption #autoPns="matAutocomplete">
            @for (pns of pnsArray(); track pns) {
              <mat-option [value]="pns.referenceName">
                <span> {{ pns.referenceName }} </span>
              </mat-option>
            }
          </mat-autocomplete>
        </div>
      </div>
      <div class="flex flex-col my-6">
        <span class="font-semibold text-dnv-secondary mb-2">{{
          'NAVBAR.FILTERS.LABEL_AUTHOR' | translate
        }}</span>
        <div class="border border-dnv-primary rounded-full p-3">
          <input
            type="text"
            [placeholder]="'NAVBAR.FILTERS.PLACEHOLDER_AUTHOR' | translate"
            matInput
            formControlName="author"
            [matAutocomplete]="autoAuthor"
            class="w-full border-none outline-none focus:outline-none bg-transparent"
          />
          <mat-autocomplete autoActiveFirstOption #autoAuthor="matAutocomplete">
            @for (author of authorArray(); track author) {
              <mat-option [value]="author.email">
                <span> {{ author.email }} ({{author.fullName}}) </span>
              </mat-option>
            }
          </mat-autocomplete>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex justify-between items-center w-full">
    <button mat-stroked-button (click)="cancelFiltersDialog()">
      {{ 'NAVBAR.FILTERS.DELETE_BUTTON' | translate }}
    </button>
    <div>
      <button mat-stroked-button (click)="resetFilters()">
        {{ 'NAVBAR.FILTERS.RESET_BUTTON' | translate }}
      </button>
      <button mat-flat-button (click)="applyFilters()">
        {{ 'NAVBAR.FILTERS.APPLY_BUTTON' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
